import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GoogleMapsLoaderService } from './shared/services/google-maps-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  googleMapService = inject(GoogleMapsLoaderService);

  constructor(
    private translateService: TranslateService) {
    this.translateService.setDefaultLang('es');
    this.translateService.use(this.translateService.defaultLang);
  }

  ngOnInit(): void {
    this.googleMapService.loadScript().catch(err => console.error('Error loading Google Maps', err))
  }

}
